const getStatusSettings = () => ({
    items: {
        open: { id: 'open', name: 'offen' },
        email_sent: { id: 'email_sent', name: 'Email gesendet'},
        booked: { id: 'booked', name: 'gebucht'},
        closed: { id: 'closed', name: 'geschlossen' },
        undefined: { id: 'undefined', name: 'undefiniert'}
    },
    order: ['open', 'email_sent', 'booked', 'closed']
})

export default getStatusSettings;